import PropTypes from 'prop-types'
import { Switch } from '@components/ui/switch'
import { Label } from '@components/ui/label'
import { cn } from 'lib/utils'

export const AdasSwitch = ({
  checked,
  onChange,
  disabled,
  label,
  id,
  name,
  className,
  // eslint-disable-next-line no-unused-vars
  sx,
  ...props
}) => {
  const switchId = id || name
  const handleChange = (checkedState) => {
    if (onChange) onChange({ target: { checked: checkedState, name } })
  }
  return (
    <div className={cn('flex items-center gap-2', className)}>
      <Switch id={switchId} checked={checked} onCheckedChange={handleChange} disabled={disabled} {...props} />
      {label && (
        <Label htmlFor={switchId} className='text-sm cursor-pointer'>
          {label}
        </Label>
      )}
    </div>
  )
}

AdasSwitch.propTypes = {
  checked: PropTypes.bool,
  onChange: PropTypes.func,
  disabled: PropTypes.bool,
  label: PropTypes.string,
  id: PropTypes.string,
  name: PropTypes.string,
  className: PropTypes.string
}
